import { createAction } from '@reduxjs/toolkit';

const key = (name) => `FSW_${name}`;
const action = (name) => createAction(key(name));

export const setDevScope = action('SET_DEV_SCOPE');
